import { PropsWithChildren } from "react";
import { ThemeProvider as StyledComponentsThemeProvider } from "styled-components";
import { defaultTheme } from "../shared/constants";
import { Theme } from "../shared/types";
import { GlobalFonts } from "./assets/fonts/globalFonts";

export const ThemeProvider = (props: PropsWithChildren<{ theme?: Theme }>) => {
  const finalTheme = props.theme ?? defaultTheme;

  return (
    <StyledComponentsThemeProvider theme={finalTheme}>
      <GlobalFonts />
      {props.children}
    </StyledComponentsThemeProvider>
  );
};
